module.exports = __webpack_public_path__ + "img/max-file-search--pdf.499b1636.svg";